import { styled, Select, InputLabel } from "@mui/material";


export const StyledInputLabel = styled(InputLabel)(() => ({
  "&.Mui-focused": {
    color: "rgb(17,75,118)",
  },
}));

export const StyledSelect = styled(Select)(() => ({
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(73,80,87,0.8)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(17,75,118,0.8)",
  },
}))